import React from "react";
import { useContent } from "../../../contexts/contentContext/contentContext.js";
import Link, { LinkToNewTab } from "../../Elements/Link/Link.js";
import { useUser } from "../../../contexts/userContext/userContext.js";
import Icon from "../../Elements/Icon/Icon.tsx";
export const MobileAboutSection = () => {
  const { getTextByKey } = useContent();
  const { getUserData } = useUser();
  return (
    <div className="footer-about footer-about-mobile-view">
      <div className="footer-mobile-resize-font">
        <LinkToNewTab page={"about"}>{getTextByKey("about-us")}</LinkToNewTab>
        <span>|</span>
        <LinkToNewTab page="features">{getTextByKey("features")}</LinkToNewTab>
        <span>|</span>
        <LinkToNewTab page="codes/jumbocode-recovery">
          {getTextByKey("jumbocodes")}
        </LinkToNewTab>
        <span>|</span>
        <LinkToNewTab page="news">
          {getTextByKey("news-footer-mobile")}
        </LinkToNewTab>
      </div>
      <div className="footer-mobile-resize-font">
        <LinkToNewTab page="terms">{getTextByKey("terms-footer")}</LinkToNewTab>
        <span>|</span>
        {(getUserData().UserCountry === "Israel" ||
          getUserData().UserCountry === undefined) && (
          <>
            <LinkToNewTab page="jumbo-pay-terms">
              {getTextByKey("jumbopay-terms")}
            </LinkToNewTab>
            <span>|</span>
          </>
        )}
        <LinkToNewTab page="cookie-policy">
          {getTextByKey("cookie-policy")}
        </LinkToNewTab>
        <span>|</span>
        <LinkToNewTab page="privacy-policy">
          {getTextByKey("privacy-policy")}
        </LinkToNewTab>
      </div>
      <div className="footer-mobile-resize-font">
        <LinkToNewTab page="accessibility">
          {getTextByKey("accessibility")}
        </LinkToNewTab>
      </div>
      <div className="social-media-icons-container">
        <LinkToNewTab
          fullUrl={true}
          page="https://www.facebook.com/jumbomail.me"
          isNewTab={true}
        >
          <Icon name="facebook" white xl />
        </LinkToNewTab>
        <LinkToNewTab
          fullUrl={true}
          page="https://www.x.com/jumbomail_me"
          isNewTab={true}
        >
          <Icon name="x-twitter" white xl />
        </LinkToNewTab>
        <LinkToNewTab
          fullUrl={true}
          page="https://www.instagram.com/jumbo.mail.me"
          isNewTab={true}
        >
          <Icon name="instagram" white xl />
        </LinkToNewTab>
        <LinkToNewTab
          fullUrl={true}
          page="https://www.linkedin.com/company/jumbomail"
          isNewTab={true}
        >
          <Icon name="linkedin" white xl />
        </LinkToNewTab>
      </div>
    </div>
  );
};
